export default __webpack_public_path__ + "static/media/group_life_light.8679a8fc.png";